/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Pass_Iap_Single_PassInputs */

const en_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single VIP Pass`)
};

const ar_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تذكرة مرور فردية لكبار الشخصيات`)
};

const de_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelner VIP-Pass`)
};

const es_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pase VIP individual`)
};

const fr_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe VIP unique`)
};

const it_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass VIP singolo`)
};

const ja_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シングルVIPパス`)
};

const ko_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`싱글 VIP 패스`)
};

const pt_br_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passaporte VIP único`)
};

const ru_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Единый VIP-пропуск`)
};

const th_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัตรผ่าน VIP แบบครั้งเดียว`)
};

const tr_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek Kişilik VIP Bileti`)
};

const zh_cn_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单次 VIP 通行证`)
};

const zh_tw_focus_pass_iap_single_pass = /** @type {(inputs: Focus_Pass_Iap_Single_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`單次 VIP 通行證`)
};

/**
* | output |
* | --- |
* | "Single VIP Pass" |
*
* @param {Focus_Pass_Iap_Single_PassInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_iap_single_pass = /** @type {((inputs?: Focus_Pass_Iap_Single_PassInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Iap_Single_PassInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_iap_single_pass(inputs)
	if (locale === "ar") return ar_focus_pass_iap_single_pass(inputs)
	if (locale === "de") return de_focus_pass_iap_single_pass(inputs)
	if (locale === "es") return es_focus_pass_iap_single_pass(inputs)
	if (locale === "fr") return fr_focus_pass_iap_single_pass(inputs)
	if (locale === "it") return it_focus_pass_iap_single_pass(inputs)
	if (locale === "ja") return ja_focus_pass_iap_single_pass(inputs)
	if (locale === "ko") return ko_focus_pass_iap_single_pass(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_iap_single_pass(inputs)
	if (locale === "ru") return ru_focus_pass_iap_single_pass(inputs)
	if (locale === "th") return th_focus_pass_iap_single_pass(inputs)
	if (locale === "tr") return tr_focus_pass_iap_single_pass(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_iap_single_pass(inputs)
	return zh_tw_focus_pass_iap_single_pass(inputs)
});